/* eslint-disable react/jsx-props-no-spreading */
import { useMemo } from "react";
import { Provider } from "react-redux";
import EmailAllModal from "./EmailAllModal";

export default function EmailAllModalApp(props) {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <EmailAllModal
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </Provider>
  );
}
